// Hospital Dashboard Mock Data

// Key statistics data
export const dashboardSummary = {
  admissions: {
    active: 43,
    total: 67,
    pending: 12
  },
  beds: {
    total: 120,
    occupied: 98,
    available: 22,
    occupancyRate: 82
  },
  tasks: {
    critical: 8,
    dueToday: 27,
    total: 84
  },
  surgeries: {
    today: 14,
    scheduled: 32
  },
  theatres: {
    active: 3,
    total: 5
  }
}

// Staff statistics data
export const staffSummary = {
  doctors: {
    onDuty: 12,
    total: 22
  },
  nurses: {
    onDuty: 34,
    total: 47
  },
  specialists: {
    onDuty: 7,
    total: 15
  }
}

// Department statistics data
export const departmentSummary = [
  { department: 'Cardiology', occupancy: 91, admissionsToday: 5, dischargesExpected: 3 },
  { department: 'Orthopedics', occupancy: 78, admissionsToday: 6, dischargesExpected: 4 },
  { department: 'Neurology', occupancy: 85, admissionsToday: 2, dischargesExpected: 5 },
  { department: 'Pediatrics', occupancy: 62, admissionsToday: 7, dischargesExpected: 8 },
  { department: 'Oncology', occupancy: 95, admissionsToday: 3, dischargesExpected: 1 },
  { department: 'General', occupancy: 74, admissionsToday: 8, dischargesExpected: 6 }
]

// Ward statistics data
export const wardSummary = [
  { ward: 'Ward A (Cardiology)', beds: 24, occupied: 22, available: 2 },
  { ward: 'Ward B (Orthopedics)', beds: 20, occupied: 16, available: 4 },
  { ward: 'Ward C (Neurology)', beds: 18, occupied: 15, available: 3 },
  { ward: 'Ward D (Pediatrics)', beds: 22, occupied: 14, available: 8 },
  { ward: 'Ward E (Oncology)', beds: 18, occupied: 17, available: 1 },
  { ward: 'Ward F (General)', beds: 18, occupied: 14, available: 4 }
]

// Alert messages
export const alertMessages = [
  { id: 1, type: 'critical', message: 'Critical medication shortage in Ward E', time: '10 minutes ago' },
  { id: 2, type: 'warning', message: 'Bed capacity at 95% in Oncology department', time: '25 minutes ago' },
  { id: 3, type: 'info', message: 'New admission protocol published', time: '1 hour ago' },
  { id: 4, type: 'critical', message: 'Emergency surgery required for patient in Room 304', time: '15 minutes ago' },
  { id: 5, type: 'warning', message: 'Staff shortage in Ward A for night shift', time: '2 hours ago' }
]

// Recent admissions data
export const recentAdmissions = [
  {
    admissionId: 'ADM-8762',
    patientName: 'James Wilson',
    patientId: 'PT-1087',
    admissionDate: '2023-06-15T09:30:00',
    department: 'Cardiology',
    status: 'Active',
    roomNumber: '205',
    admittingDoctor: 'Dr. Sarah Johnson'
  },
  {
    admissionId: 'ADM-8761',
    patientName: 'Emily Parker',
    patientId: 'PT-1086',
    admissionDate: '2023-06-15T08:15:00',
    department: 'Orthopedics',
    status: 'Active',
    roomNumber: '310',
    admittingDoctor: 'Dr. Robert Chen'
  },
  {
    admissionId: 'ADM-8760',
    patientName: 'Michael Brown',
    patientId: 'PT-1045',
    admissionDate: '2023-06-15T07:20:00',
    department: 'Neurology',
    status: 'Pending',
    roomNumber: '-',
    admittingDoctor: 'Dr. Emily Taylor'
  },
  {
    admissionId: 'ADM-8759',
    patientName: 'Sophia Lee',
    patientId: 'PT-1085',
    admissionDate: '2023-06-14T16:40:00',
    department: 'Pediatrics',
    status: 'Active',
    roomNumber: '118',
    admittingDoctor: 'Dr. Marcus West'
  },
  {
    admissionId: 'ADM-8758',
    patientName: 'Noah Martinez',
    patientId: 'PT-1084',
    admissionDate: '2023-06-14T14:10:00',
    department: 'General',
    status: 'Discharged',
    roomNumber: '412',
    admittingDoctor: 'Dr. Lisa Wong'
  },
  {
    admissionId: 'ADM-8757',
    patientName: 'Emma Wilson',
    patientId: 'PT-1023',
    admissionDate: '2023-06-14T11:25:00',
    department: 'Oncology',
    status: 'Active',
    roomNumber: '522',
    admittingDoctor: 'Dr. James Wilson'
  }
]

// Upcoming surgeries data
export const upcomingSurgeries = [
  {
    surgeryId: 'SRG-4578',
    patientName: 'David Miller',
    patientId: 'PT-1073',
    scheduledDateTime: '2023-06-15T13:30:00',
    surgeryType: 'Coronary Bypass',
    surgeryRoom: 'Theatre 1',
    assignedSurgeon: 'Dr. Sarah Johnson',
    anaesthesiologist: 'Dr. Daniel Wright',
    duration: 240,
    urgency: 'Urgent',
    preOpStatus: 'Ready',
    notes: 'Patient has history of hypertension'
  },
  {
    surgeryId: 'SRG-4579',
    patientName: 'Sarah Thompson',
    patientId: 'PT-1061',
    scheduledDateTime: '2023-06-15T14:00:00',
    surgeryType: 'Hip Replacement',
    surgeryRoom: 'Theatre 2',
    assignedSurgeon: 'Dr. Robert Chen',
    anaesthesiologist: 'Dr. Emma Taylor',
    duration: 180,
    urgency: 'Elective',
    preOpStatus: 'Ready',
    notes: ''
  },
  {
    surgeryId: 'SRG-4580',
    patientName: 'John Davis',
    patientId: 'PT-1092',
    scheduledDateTime: '2023-06-15T15:30:00',
    surgeryType: 'Appendectomy',
    surgeryRoom: 'Theatre 3',
    assignedSurgeon: 'Dr. Lisa Wong',
    anaesthesiologist: 'Dr. Amanda Parker',
    duration: 90,
    urgency: 'Emergency',
    preOpStatus: 'Ready',
    notes: 'Patient admitted through ER'
  },
  {
    surgeryId: 'SRG-4581',
    patientName: 'Jennifer Adams',
    patientId: 'PT-1055',
    scheduledDateTime: '2023-06-16T09:00:00',
    surgeryType: 'Cataract Removal',
    surgeryRoom: 'Theatre 4',
    assignedSurgeon: 'Dr. Melissa Khan',
    anaesthesiologist: 'Dr. Daniel Wright',
    duration: 60,
    urgency: 'Elective',
    preOpStatus: 'Scheduled',
    notes: 'Right eye procedure'
  },
  {
    surgeryId: 'SRG-4582',
    patientName: 'Michael Brown',
    patientId: 'PT-1045',
    scheduledDateTime: '2023-06-16T11:00:00',
    surgeryType: 'Spinal Fusion',
    surgeryRoom: 'Theatre 1',
    assignedSurgeon: 'Dr. James Wilson',
    anaesthesiologist: 'Dr. Emma Taylor',
    duration: 210,
    urgency: 'Urgent',
    preOpStatus: 'Scheduled',
    notes: 'Confirmed lumbar disc herniation'
  },
  {
    surgeryId: 'SRG-4583',
    patientName: 'Elizabeth Chen',
    patientId: 'PT-1097',
    scheduledDateTime: '2023-06-16T13:30:00',
    surgeryType: 'Laparoscopic Cholecystectomy',
    surgeryRoom: 'Theatre 2',
    assignedSurgeon: 'Dr. Thomas Wright',
    anaesthesiologist: 'Dr. Amanda Parker',
    duration: 120,
    urgency: 'Elective',
    preOpStatus: 'Scheduled',
    notes: 'Patient has gallstones'
  }
]

// Tasks due today
export const tasksDueToday = [
  {
    taskId: 'TASK-5761',
    taskDescription: 'Pre-op assessment for coronary bypass',
    patientName: 'David Miller',
    patientId: 'PT-1073',
    assignedToStaffName: 'Nurse Sarah Collins',
    dueDate: '2023-06-15T11:00:00',
    taskStatus: 'Pending',
    priority: 'Critical',
    department: 'Cardiology'
  },
  {
    taskId: 'TASK-5762',
    taskDescription: 'Administer IV antibiotics',
    patientName: 'Emma Wilson',
    patientId: 'PT-1023',
    assignedToStaffName: 'Nurse Michael Chen',
    dueDate: '2023-06-15T12:00:00',
    taskStatus: 'In Progress',
    priority: 'High',
    department: 'Oncology'
  },
  {
    taskId: 'TASK-5763',
    taskDescription: 'Change dressing for post-op wound',
    patientName: 'James Wilson',
    patientId: 'PT-1087',
    assignedToStaffName: 'Nurse Sarah Collins',
    dueDate: '2023-06-15T13:30:00',
    taskStatus: 'Pending',
    priority: 'Medium',
    department: 'Cardiology'
  },
  {
    taskId: 'TASK-5764',
    taskDescription: 'Physical therapy session',
    patientName: 'Emily Parker',
    patientId: 'PT-1086',
    assignedToStaffName: 'Dr. Thomas Wright',
    dueDate: '2023-06-15T14:00:00',
    taskStatus: 'Scheduled',
    priority: 'Medium',
    department: 'Orthopedics'
  },
  {
    taskId: 'TASK-5765',
    taskDescription: 'Discharge planning discussion',
    patientName: 'Sophia Lee',
    patientId: 'PT-1085',
    assignedToStaffName: 'Dr. Marcus West',
    dueDate: '2023-06-15T15:30:00',
    taskStatus: 'Pending',
    priority: 'Medium',
    department: 'Pediatrics'
  },
  {
    taskId: 'TASK-5766',
    taskDescription: 'Blood transfusion',
    patientName: 'Emma Wilson',
    patientId: 'PT-1023',
    assignedToStaffName: 'Nurse Amanda Rodriguez',
    dueDate: '2023-06-15T16:00:00',
    taskStatus: 'Scheduled',
    priority: 'Critical',
    department: 'Oncology'
  },
  {
    taskId: 'TASK-5767',
    taskDescription: 'Post-op vital signs monitoring',
    patientName: 'John Davis',
    patientId: 'PT-1092',
    assignedToStaffName: 'Nurse Michael Chen',
    dueDate: '2023-06-15T16:30:00',
    taskStatus: 'Pending',
    priority: 'High',
    department: 'General'
  }
]

// Active theatre rooms data
export const activeTheatres = [
  {
    theatreId: 'THEATRE-1',
    theatreName: 'Operating Room 1',
    status: 'Active',
    currentProcedure: 'Appendectomy',
    patient: 'Kevin Thompson (PT-1542)',
    surgeon: 'Dr. Sarah Johnson',
    startTime: '2025-04-02T08:30:00',
    estimatedEndTime: '2025-04-02T09:00:00',
    nextProcedure: 'Hernia Repair',
    nextPatient: 'Laura Martinez (PT-1563)',
    nextStartTime: '2025-04-02T10:30:00'
  },
  {
    theatreId: 'THEATRE-2',
    theatreName: 'Operating Room 2',
    status: 'Active',
    currentProcedure: 'Hip Replacement',
    patient: 'Rebecca Martinez (PT-1079)',
    surgeon: 'Dr. Robert Chen',
    startTime: '2025-04-02T07:45:00',
    estimatedEndTime: '2025-04-02T10:15:00',
    nextProcedure: 'Knee Arthroscopy',
    nextPatient: 'Sarah Thompson (PT-1061)',
    nextStartTime: '2025-04-02T11:00:00'
  },
  {
    theatreId: 'THEATRE-3',
    theatreName: 'Operating Room 3',
    status: 'Setup',
    currentProcedure: null,
    patient: null,
    surgeon: null,
    startTime: null,
    estimatedEndTime: null,
    nextProcedure: 'Cholecystectomy',
    nextPatient: 'Michael Rodriguez (PT-1053)',
    nextStartTime: '2025-04-02T09:30:00'
  },
  {
    theatreId: 'THEATRE-4',
    theatreName: 'Operating Room 4',
    status: 'Active',
    currentProcedure: 'Cataract Removal',
    patient: 'Jennifer Adams (PT-1055)',
    surgeon: 'Dr. Melissa Khan',
    startTime: '2025-04-02T08:15:00',
    estimatedEndTime: '2025-04-02T09:15:00',
    nextProcedure: 'Laser Eye Surgery',
    nextPatient: 'Robert Chen (PT-1099)',
    nextStartTime: '2025-04-02T10:00:00'
  },
  {
    theatreId: 'THEATRE-5',
    theatreName: 'Operating Room 5',
    status: 'Cleaning',
    currentProcedure: null,
    patient: null,
    surgeon: null,
    startTime: null,
    estimatedEndTime: null,
    nextProcedure: 'Hernia Repair',
    nextPatient: 'William Taylor (PT-1091)',
    nextStartTime: '2025-04-02T11:30:00'
  },
  {
    theatreId: 'THEATRE-6',
    theatreName: 'Operating Room 6',
    status: 'Setup',
    currentProcedure: null,
    patient: null,
    surgeon: null,
    startTime: null,
    estimatedEndTime: null,
    nextProcedure: 'Tonsillectomy',
    nextPatient: 'Emily Wilson (PT-1103)',
    nextStartTime: '2025-04-02T09:45:00'
  }
]
